import i18next from 'i18next';
import ua from './uk.json';
import en from './en.json';

const lang = document.querySelector('html').getAttribute('lang');



i18next.init({
  debug: true,
  preload: true,
  initImmediate: false,
  lng: lang,
  fallbackLng: lang,
  resources: {
      uk: {
      translation: ua,
    },
    en: {
      translation: en,
    },
  },
});

export default i18next;
